import React, {
  FC, useMemo, useState, useEffect,
} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import classnames from 'classnames';
import SchemaForm from 'app/components/general/SchemaForm';
import { Link } from 'react-router-dom';
import history from 'app/routes/history';

import PaymentCollectionsTable from 'app/components/teamPaymentRequests/PaymentCollectionsTable';
import SectionGroup from 'app/components/general/SectionGroup';

import * as teamPaymentCollectionsActions from 'app/ducks/teamPaymentCollections/actions';
import * as paymentEventsActions from 'app/ducks/paymentEvents/actions';
import * as teamMembersActions from 'app/ducks/teamMembers/actions';

import * as loadingSelectors from 'app/ducks/loading/selectors';
import * as teamPaymentCollectionsSelectiors from 'app/ducks/teamPaymentCollections/selectors';
import * as teamMembersSelectors from 'app/ducks/teamMembers/selectors';
import * as paymentEventsSelectiors from 'app/ducks/paymentEvents/selectors';

function selector(state): any {
  return {
    appReady: loadingSelectors.appReady(state),
    teamPaymentCollections: teamPaymentCollectionsSelectiors.getTeamPaymentCollections(state),
    paymentEvents: paymentEventsSelectiors.getPaymentEvents(state),
    teamMembers: teamMembersSelectors.getTeamMembers(state),
  };
}

const actionCreators = _.merge(teamPaymentCollectionsActions, paymentEventsActions, teamMembersActions);

interface IProps {
  appReady: boolean;
  teamManager: any;
  team: any;
  teamMembers: any;
  teamPaymentCollections: any;
  paymentEvents: any;
  actions: any;
  errors: any;
  match: any;
  afterSubmit: Function;
}
const Overview: FC<IProps> = (props: IProps = {
  appReady: false,
  teamPaymentCollections: undefined,
  paymentEvents: undefined,
  teamManager: undefined,
  team: undefined,
  teamMembers: undefined,
  actions: undefined,
  errors: undefined,
  match: undefined,
  afterSubmit: undefined,
}) => {
  useEffect(() => {
    props.actions.getAllTeamMembersTeamMemberView({}, true, props.match.params.teamCode, props.match.params.teamMemberCode);
    props.actions.getAllTeamPaymentCollectionsTeamMemberView({}, true, props.match.params.teamCode, props.match.params.teamMemberCode);
  }, []);

  // const groupIds = [props.team?.group?.id];
  const currentTeamMember = (): any => {
    const teamMemberCurrentId = props.teamMembers.teamMemberIds[0];
    if (_.isEmpty(teamMemberCurrentId)) {
      return {};
    }
    return props.teamMembers.teamMembersById[teamMemberCurrentId];
  };

  return (
    <div>
      <div className="row">
        <div className="col">
          <SectionGroup title="Your details">
            <div className="row">
              <div className="col col-3">
                Name
              </div>
              <div className="col">
                {currentTeamMember().fullName}
              </div>
            </div>
          </SectionGroup>
        </div>
      </div>
      <div className="row with-margin-top-extra">
        <div className="col">
          <PaymentCollectionsTable
            {...props.teamPaymentCollections}
            headerTitle="Your Payments"
            appReady={props.appReady}
            actions={props.actions}
            saveFilters={false}
            isLoading={props.teamPaymentCollections.isLoading}
            selectPaymentCollection={props.actions.selectPaymentCollection}
            teamCode={props.match.params.teamCode}
            teamMemberCode={props.match.params.teamMemberCode}
          />
        </div>
      </div>
      {/* <div className={classnames('row with-margin-top-extra', { 'd-none': _.isEmpty(props.team?.group?.id) })}>
        <div className="col">
          <MatchesTableTeamMemberView
            headerTitle="Your Team's Matches"
            {...props.paymentEvents}
            groupIds={groupIds}
            appReady={props.appReady}
            selectTeam={props.actions.selectTeam}
            actions={props.actions}
          />
        </div>
      </div> */}
    </div>
  );
};

export default connect(selector, (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
}))(Overview);
